<template>
  <ContentLayout
    :title="$t('label_essweb_holidayGroup_list_title')"
    pad="0"
    :addBtn="hasBtn('add-admin-public-holiday-group')"
    @new="toNew"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :height="$vuetify.breakpoint.height - 275"
        :showSelect="showSelect"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback) => {
            getList(page, perpage, callback);
          }
        "
      >
        <template v-slot:item.name="{ item }">
          <div class="text--primary table-title">
            {{ $getCommonLangValue(item.holiday_group_name) }}
          </div>
          <div class="text--secondary table-subtitle">
            {{ $getCommonLangValue(item.holiday_group_description) }}
          </div>
        </template>

        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :editBtn="hasBtn('edit-admin-public-holiday-group')"
            :delBtn="hasBtn('delete-admin-public-holiday-group')"
            :viewBtn="hasBtn('view-admin-public-holiday-group')"
            :title="$t('label_essweb_holidayGroup_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "PublicHolidayGroup",
  computed: {},
  mounted() {
    this.getBtnPermissionList();
    this.getList(1, this.$tableSetting.perPageSize, null);
  },
  data() {
    return {
      search: "",
      showSelect: false,
      selected: [],
      totalCount: 0,
      headers: [
        {
          text: "label_essweb_holidayGroup_list_publicHolidayGroupLabel",
          value: "name",
          align: "start",
          sortable: false,
          filter: (value, search, item) => {
            if (!this.search) return true;
            return (
              item.holiday_group_name
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1
            );
          },
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
    };
  },
  methods: {
    getList: function (page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_group",
        url: "/holiday-group/get-holiday-group-list/",
        data: { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback() : null;
      });
    },
    toDelete: function (uuid) {
      // 2020-09-03修改为不删除
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_group",
        url: "/holiday-group/delete-holiday-group-table/",
        data: { uuids: uuid },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_holidayGroup_list_deletePublicHolidayGroupSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== uuid);
      });
    },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/holiday-group/edit/"
          : "/admin/holiday-group/detail/") + uuid
      );
    },
    toNew: function () {
      this.$toPage("/admin/holiday-group/add", {});
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>
<style scoped>
.leftYear:hover::-webkit-scrollbar {
  display: inline-block;
  width: 5px;
}
</style>
